<label
  for="typeahead-focus"
  class="input-title"
  [class.text-error]="didSubmit && !list">
  Methodology
</label>
<ng-select
  [items]="methodologies"
  [ngModelOptions]="{standalone: true}"
  bindLabel='name'
  [(ngModel)]="list"
  [virtualScroll]="true"
  (change)="getValue($event)"
  [searchable]='true'
  placeholder="start typing a name"
  class="custom select-check-value">
</ng-select>
